import { NumberInput, Box } from '@mantine/core';
import { ReactNode } from 'react';

import { BorderThemeProps } from 'shared/common/themes/theme';
import { ThemeColorInput } from 'shared/components/themes/ThemeColorInput';

import classes from './BorderPanel.module.scss';
import { SelectBorderStyle } from '../SelectBorderStyle';
import { ThemeControl } from '../ThemeControl';

type BorderPanelProps = {
  resetButton?: ReactNode;
  border: BorderThemeProps;
  colorGlobalPath?: string;
  label?: string;
  path?: string;
  fourBordersPaths?: string[];
  setBorder: (newValue: BorderThemeProps) => void;
  themeControlClassName?: string;
};

export const BorderPanel = (props: BorderPanelProps) => {
  const { border, colorGlobalPath, label, path, fourBordersPaths, setBorder, themeControlClassName, resetButton } =
    props;

  const { borderColor, borderStyle, borderWidth } = border;

  return (
    <Box className={classes.fullWidthContainer}>
      <ThemeControl
        label={label}
        path={path}
        pathsBatch={fourBordersPaths}
        partialGlobalPath={colorGlobalPath}
        className={themeControlClassName}
      >
        <ThemeColorInput
          color={borderColor ?? ''}
          onSelectColor={colorObject => setBorder({ ...border, borderColor: colorObject.color })}
        />
        <Box className={classes.numberInput}>
          <NumberInput
            value={borderWidth}
            onChange={width => setBorder({ ...border, borderWidth: +width || 0 })}
            min={0}
          />
        </Box>
        <SelectBorderStyle value={borderStyle} onChange={style => setBorder({ ...border, borderStyle: style })} />
        {resetButton}
      </ThemeControl>
    </Box>
  );
};
